import { Link } from 'react-router-dom';
import { Wordmark } from './Wordmark';

export function Footer() {
  return (
    <footer className="bg-canvas border-t border-hairline">
      <div className="container-site py-10">
        <div className="flex flex-wrap items-center justify-between gap-6">
          <Wordmark size="md" />
          <div className="flex flex-wrap items-center gap-4 font-mono text-[0.6875rem] uppercase tracking-[0.125em] text-ink-muted">
            <a
              href="mailto:info@zacharycompanies.com"
              className="hover:text-ink transition-colors"
            >
              info@zacharycompanies.com
            </a>
            <span className="text-ink-subtle" aria-hidden="true">
              ·
            </span>
            <a href="tel:+19524443174" className="hover:text-ink transition-colors">
              952-444-3174
            </a>
          </div>
        </div>

        <div className="mt-6 border-t border-hairline pt-6 flex flex-wrap items-center justify-between gap-4 text-xs text-ink-subtle">
          <p>
            &copy; {new Date().getFullYear()} The Zachary Group &middot; Based in Bloomington, MN
          </p>
          <Link to="/privacy" className="hover:text-ink transition-colors">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
